import { FirebaseProviderState } from './FirebaseProvider.types';
import { createContext } from 'react'

export const FirebaseProviderContext = createContext<FirebaseProviderState | undefined>(undefined);